import WIcon from "./WIcon"

export default WIcon
